import { render, staticRenderFns } from "./SlsL.vue?vue&type=template&id=66714716"
import script from "./SlsL.vue?vue&type=script&lang=js"
export * from "./SlsL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports